"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _core = require("@material-ui/core");
var _colors = require("@material-ui/core/colors");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _Image = require("./Image");
var _TopChips = require("./TopChips");
var _MainInfo = require("./MainInfo");
var _DescriptionInfo = require("./DescriptionInfo");
var _TagsInfo = require("./TagsInfo");
var _SpecificitiesInfo = require("./SpecificitiesInfo");
var _ActionsButtons = require("./ActionsButtons");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ProductInfo = function ProductInfo(props) {
  var product = props.product,
    onClose = props.onClose;
  var Image = props.imageComponent || _Image.Image;
  var TopChips = props.topChipsComponent || _TopChips.TopChips;
  var MainInfo = props.mainInfoComponent || _MainInfo.MainInfo;
  var DescriptionInfo = props.descriptionInfoComponent || _DescriptionInfo.DescriptionInfo;
  var TagsInfo = props.tagsInfoComponent || _TagsInfo.TagsInfo;
  var SpecificitiesInfo = props.specificitiesInfoComponent || _SpecificitiesInfo.SpecificitiesInfo;
  var ActionsButtons = props.actionsButtonsComponent || _ActionsButtons.ActionsButtons;
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "320px"
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    padding: 1.5,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h5"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Info"
  })), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, "close"))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    padding: 1.5,
    flex: 1,
    overflow: "auto",
    bgcolor: _colors.grey[100]
  }, /*#__PURE__*/_react.default.createElement(Image, {
    product: product
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    position: "absolute",
    bottom: 8,
    right: 8,
    zIndex: 9
  }, /*#__PURE__*/_react.default.createElement(TopChips, {
    product: product
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(MainInfo, {
    product: product
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    marginTop: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Divider, null)), !_lodash.default.isEmpty(product.description) && /*#__PURE__*/_react.default.createElement(DescriptionInfo, {
    product: product
  }), !_lodash.default.isEmpty(product.tags) && /*#__PURE__*/_react.default.createElement(TagsInfo, {
    product: product
  }), !_lodash.default.isEmpty(product.product_specificities) && /*#__PURE__*/_react.default.createElement(SpecificitiesInfo, {
    product: product
  }), props.renderExtraCollapses && props.renderExtraCollapses(product)), /*#__PURE__*/_react.default.createElement(ActionsButtons, _extends({
    product: product
  }, props)));
};
exports.ProductInfo = ProductInfo;